import axios from 'axios';
// import { logout } from './services/authService';  // A service to handle logout
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { ErrorHandlingService } from './errorHandler';
import { convertLocalToUTC, convertUTCToLocal } from './components/utils/dateUtils'; // Import date utilities

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
      },
});

// TODO: Have single logout function in one place
const logout = async () => {
    localStorage.clear();
  
    try {
      const response = await axiosInstance.get('/api/auth/logout');
      if (response.status === 200) {
        window.location.href = '/login';
      }
    } catch (error) {
      console.log('Login failed:', error);
      return false;
    }
  };

 // Add request interceptor to handle outgoing requests
axiosInstance.interceptors.request.use(
    (config) => {
      if (config.data) {
        // Process all data in the request payload
        for (const key in config.data) {
            if (typeof config.data[key] === 'string' && Date.parse(config.data[key] && config.data[key] instanceof Date)) {
            // Convert Date objects to UTC ISO string
            config.data[key] = convertLocalToUTC(config.data[key]);
          }
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );


  // Add a response interceptor to handle 401 errors globally
 // Response interceptor
 axiosInstance.interceptors.response.use(
    (response) => {
        if (response.data) {
            // Process all data in the response payload
            for (const key in response.data) {
                if (typeof response.data[key] === 'string' && Date.parse(response.data[key]) && response.data[key] instanceof Date) {
                    // Convert UTC date strings to local timezone
                    response.data[key] = convertUTCToLocal(response.data[key]);
                }
            }
        }
        return response;
    },
     (error) => {
        const statusCode = error.response?.status;
        const errorMessage = error.response?.data?.message || 'An error occurred';

        // Log the error
        ErrorHandlingService.logError(error, { 
            statusCode,
            errorMessage,
            url: error.config?.url
        });

        // Check if error toast should be suppressed based on URL patterns or config flag
        // Supress as we have fallback for IRB Documents
        const suppressErrorToast = error.config?.suppressErrorToast ||
                                 error.config?.url?.includes('/api/requests/progress/by-irb-ref/') || 
                                 error.config?.url?.includes('/api/requests/enduser/request-progress-data/') ||
                                 error.config?.url?.includes('/api/requests/request-progress-data/');

        // Skip toast messages if suppressed
        if (suppressErrorToast) {
            return Promise.reject(error);
        }
 
         // Handle different error types
         switch (statusCode) {
             case 401:
                 // Unauthorized - handle logout
                 if (!window.location.href.includes('login')) {
                     logout();
                     toast.error(t('session.expired'), { position: "top-center" });
                 }
                 break;
 
             case 403:
                 // Forbidden
                 toast.error(t('error.forbidden'), { position: "top-center" });
                //  window.location.href = '/error/403';
                 break;
 
             case 404:
                 // Not Found
                 toast.error(t('error.notFound'), { position: "top-center" });
                 window.location.href = '/error/404';
                 break;
 
             case 500:
                 // Server Error
                 toast.error(t('error.server'), { position: "top-center" });
                //  window.location.href = '/error/500';
                 break;
 
             default:
                 // Handle other errors
                 if (!error.response) {
                     // Network error
                     toast.error(t('error.network'), { position: "top-center" });
                 } else {
                     toast.error(t(errorMessage), { position: "top-center" });
                 }
         }
 
         return Promise.reject(error);
     }
 );

export default axiosInstance;